import PhraseParentheses from "../PhraseParentheses";
import { tagInfo } from "../constants";

const AdvancedTokenElement = ({
  currentPage,
  handleClickToken,
  element,
  elementIndex,
  lineHeight,
}) => {
  const isSelectable = !currentPage.isSubmitted;

  return (
    <div
      key={"token_" + elementIndex}
      style={{
        display: "flex",
        position: "relative",
      }}
    >
      {currentPage.groupData[element.index] && (
        <div
          style={{
            position: "absolute",
            height: "42px",
            top: "21px",
            width:
              currentPage.groupData[element.index].isGroupEnd &&
              currentPage.groupData[element.index].space_right > 0
                ? "calc(100% - 5px)"
                : "100%",
            backgroundColor:
              tagInfo[currentPage.groupData[element.index].groupType]
                .backgroundColor,
            borderBottom:
              "1px solid " +
              tagInfo[currentPage.groupData[element.index].groupType].color,
          }}
        ></div>
      )}
      {currentPage.groupData[element.index] &&
        currentPage.groupData[element.index].isGroupLabel && (
          <div
            style={{
              position: "absolute",
              top: "60px",
              left: "50%",
              transform: "translateX(-50%)", // 수평 중앙 정렬
              fontSize: "16px",
              // 짧은 낱말(me) 밑에 "O(간접 목적어)" 가 접혀 세로로 늘어지지 않게 한 줄로 둔다
              whiteSpace: "nowrap",
              color:
                tagInfo[currentPage.groupData[element.index].groupType].color,
            }}
          >
            {tagInfo[currentPage.groupData[element.index].groupType].text}
          </div>
        )}

      {currentPage.phraseData[element.index]?.start.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={true} />
      ))}
      <div
        style={{
          marginTop: "20px",
          marginBottom: `calc(${lineHeight} - 20px)`,
          zIndex: 100,
          cursor: isSelectable ? "pointer" : "default",
          textDecoration: isSelectable ? "underline" : "none",
          textDecorationColor: "#737373",
          textUnderlineOffset: "5px",
        }}
        onClick={
          isSelectable
            ? () => handleClickToken(element, elementIndex)
            : undefined
        }
      >
        {element.text}
      </div>
      {currentPage.phraseData[element.index]?.end.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={false} />
      ))}
      <div>{element.space_right > 0 && " "}</div>
    </div>
  );
};

export default AdvancedTokenElement;
